"use strict";

exports.__esModule = true;
exports.default = void 0;
var _preact = require("preact");
var _classnames = _interopRequireDefault(require("classnames"));
var _AddFiles = _interopRequireDefault(require("./AddFiles.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable react/destructuring-assignment */

var AddFilesPanel = function AddFilesPanel(props) {
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('uppy-Dashboard-AddFilesPanel', props.className),
    "data-uppy-panelType": "AddFiles",
    "aria-hidden": !props.showAddFilesPanel
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-bar"
  }, (0, _preact.h)("div", {
    className: "uppy-DashboardContent-title",
    role: "heading",
    "aria-level": "1"
  }, props.i18n('addingMoreFiles')), (0, _preact.h)("button", {
    className: "uppy-DashboardContent-back",
    type: "button",
    onClick: function onClick() {
      return props.toggleAddFilesPanel(false);
    }
  }, props.i18n('back'))), (0, _preact.h)(_AddFiles.default, props));
};
var _default = exports.default = AddFilesPanel;